import { appHttpClient } from "../../../../installations/http/axiosInterfaces";
import { dedupeRequest } from "../../../../installations/http/inFlight";

// Get Item Groups
export const getItemGroups = (queryParams) => {
  // 0016: dedupe StrictMode double-invoke (the useItemGroupsQuery queryFn AND the AdminCatalog thunk
  // path) into one network request. Key on the params so different page sizes fetch independently.
  return dedupeRequest(`itemGroups:${JSON.stringify(queryParams || {})}`, () =>
    appHttpClient.get(`/ItemGroup/List`, { params: queryParams })
  );
};

// Connect Item Group with Category
export const connectItemGroupWithCategory = (categoryId, itemGroupId) => {
  return appHttpClient.post(`/ItemGroup/Category/Connect/${categoryId}/${itemGroupId}`);
};

// Disconnect Item Group from Category
export const disconnectItemGroupFromCategory = (categoryId, itemGroupId) => {
  return appHttpClient.post(`/ItemGroup/Category/Disconnect/${categoryId}/${itemGroupId}`);
};

// 0036: group image. The multipart content type MUST be set per call — the shared axios instance
// defaults to application/json and the server would then see no file at all.
export const updateItemGroupImage = (itemGroupId, data) => {
  return appHttpClient.post(`/ItemGroup/Update/Image/${itemGroupId}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Clears the locally uploaded image; the group falls back to the Rivhit picture link.
export const deleteItemGroupImage = (itemGroupId) => {
  return appHttpClient.post(`/ItemGroup/Delete/Image/${itemGroupId}`);
};

const itemGroupsService = {
  getItemGroups,
  connectItemGroupWithCategory,
  disconnectItemGroupFromCategory,
  updateItemGroupImage,
  deleteItemGroupImage,
};

export default itemGroupsService;
